/**
 * NOTAM (Notice to Airmen) closure overlay layer.
 * Large red semi-transparent circles showing aviation closure zones.
 * Matches WorldMonitor visual spec exactly.
 */

import { ScatterplotLayer } from '@deck.gl/layers';
import type { Layer } from '@deck.gl/core';
import type { NormalizedEvent } from '@/sources/base-source';

/** Layer IDs handled by this renderer. */
export const NOTAM_LAYER_IDS = new Set(['notam-closures']);

/** Create deck.gl layers for NOTAM closure zones — matching WorldMonitor. */
export function createNotamLayers(
  events: NormalizedEvent[],
  zoom: number,
): Layer[] {
  if (events.length === 0) return [];

  const opacity = Math.min(1, 0.3 + zoom * 0.1);

  return [
    new ScatterplotLayer<NormalizedEvent>({
      id: 'notam-overlay',
      data: events,
      pickable: true,
      filled: true,
      stroked: true,
      radiusMinPixels: 8,
      radiusMaxPixels: 40,
      getPosition: (d) => d.location ? [d.location.lng, d.location.lat] : [0, 0],
      getFillColor: [255, 40, 40, 100],
      getLineColor: [255, 40, 40, 200],
      lineWidthMinPixels: 2,
      getRadius: 55000,
      opacity,
    }),
  ];
}
